export default "__VITE_ASSET__7f2130b7__"